import { Outlet, Link } from 'react-router-dom';
import { Building2 } from 'lucide-react';

export default function PublicLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <header className="border-b backdrop-blur-md bg-white/80 sticky top-0 z-30">
        <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5 hover:opacity-80 transition-opacity duration-150" data-testid="public-logo" aria-label="VerwalterHonorar.de – Verwaltungsbedarf analysieren. Angemessenes WEG-Verwalterhonorar ermitteln.">
            <div className="h-8 w-8 rounded-lg bg-primary flex items-center justify-center">
              <Building2 className="h-4 w-4 text-primary-foreground" />
            </div>
            <span className="font-semibold text-sm tracking-tight">VerwalterHonorar.de</span>
          </Link>
          <nav className="flex items-center gap-6">
            <Link to="/analyse" className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-150" data-testid="nav-analyse">
              Analyse
            </Link>
            <Link to="/login" className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-150" data-testid="nav-login">
              Verwalter-Login
            </Link>
          </nav>
        </div>
      </header>
      <main className="flex-1">
        <Outlet />
      </main>
      <footer className="border-t py-8 px-6" data-testid="footer">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-muted-foreground">
          <span>Entwickelt von Scholze-Kurz & Kurz Immobilien GmbH</span>
          <div className="flex items-center gap-6">
            <a href="https://www.hvkurz.de/impressum" target="_blank" rel="noopener noreferrer" className="hover:text-foreground transition-colors duration-150" data-testid="impressum-link">
              Impressum
            </a>
            <Link to="/datenschutz" className="hover:text-foreground transition-colors duration-150" data-testid="datenschutz-link">
              Datenschutz
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
